import SuspenseLoading from '@components/commons/SuspenseLoading';
import { AuthLayout, HomeLayout } from '@components/layouts';
import {
  Account,
  ApiList,
  ApiRegister,
  ApplicationIdList,
  ApplicationRegister,
  DeveloperList,
  DeveloperRegister,
  Login,
  SsidList,
} from '@components/pages';
import { useAppSelector } from '@hooks';
import { Routes } from '@utils/constants';
import { FC, Suspense } from 'react';
import { Routes as BrowserRoutes, Navigate, Route } from 'react-router-dom';

const publicRoutes: IAppRoute[] = [
  {
    path: Routes.LOGIN,
    element: Login,
  },
];

const privateRoutes: IAppRoute[] = [
  {
    path: Routes.ACCOUNT,
    element: Account,
  },
  {
    path: Routes.DEVELOPER_LIST,
    element: DeveloperList,
  },
  {
    path: Routes.DEVELOPER_REGISTER,
    element: DeveloperRegister,
  },
  {
    path: Routes.DEVELOPER_DETAIL,
    element: DeveloperRegister,
  },
  {
    path: Routes.DEVELOPER_DETAIL_APPLICATONS,
    element: ApplicationIdList,
  },
  {
    path: Routes.DEVELOPER_DETAIL_APPLICATONS_REGISTER,
    element: ApplicationRegister,
  },
  {
    path: Routes.DEVELOPER_DETAIL_APPLICATONS_DETAIL,
    element: ApplicationRegister,
  },
  {
    path: Routes.APPLICATION_DETAIL,
    element: ApplicationRegister,
  },
  {
    path: Routes.APPLICATION_REGISTER,
    element: ApplicationRegister,
  },
  {
    path: Routes.APPLICATION_LIST,
    element: ApplicationIdList,
  },
  {
    path: Routes.SSID_LIST,
    element: SsidList,
  },
  {
    path: Routes.API_LIST,
    element: ApiList,
  },
  {
    path: Routes.API_REGISTER,
    element: ApiRegister,
  },
  {
    path: Routes.API_DETAIL,
    element: ApiRegister,
  },
];

const AppRoutes: FC = () => {
  const { user } = useAppSelector((state) => state.auth);
  return (
    <BrowserRoutes>
      {!user ? (
        <Route element={<AuthLayout />}>
          {publicRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <Suspense fallback={<SuspenseLoading />}>
                  <route.element />
                </Suspense>
              }
            />
          ))}
          <Route
            path="*"
            element={<Navigate to={Routes.LOGIN} replace={true} />}
          />
        </Route>
      ) : (
        <Route element={<HomeLayout />}>
          {privateRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <Suspense fallback={<SuspenseLoading />}>
                  <route.element />
                </Suspense>
              }
            />
          ))}
          <Route
            path="*"
            element={<Navigate to={Routes.DEVELOPER_LIST} replace={true} />}
          />
        </Route>
      )}
    </BrowserRoutes>
  );
};

export default AppRoutes;
